import { TGizmoType } from '../../types';
import { Gizmo, RootGizmo } from '..';

interface IParams {
  gizmo: Gizmo | RootGizmo;
  type?: TGizmoType;
  fid?: string;
  uid?: string;
}

/**
 * Find Gizmos in the Gizmos tree that match the search criteria, right now
 * we can only search by type, if necessary we'll implement uid search later
 *
 * @param {IGizmo} config configuration tree in which we're looking for the Gizmo configuartions
 * @param {TGizmoType} type type of Gizmo we're looking for
 * @param {string} fid Flowy id of the Gizmo we're looking for
 * @param {string} uid User defined id
 *
 * @returns list of found Gizmo configurations
 */
function findGizmos({ gizmo, type, fid, uid }: IParams): (Gizmo | RootGizmo)[] {
  let foundGizmos: (Gizmo | RootGizmo)[] = [];

  const childGizmos: (Gizmo | RootGizmo)[] | undefined = gizmo.getGizmos();

  if (childGizmos && childGizmos.length > 0) {
    if (type) {
      const foundGizmosByType = childGizmos.filter(
        childGizmo => childGizmo.getConfig().type === type
      );

      if (foundGizmosByType.length > 0) {
        foundGizmos = foundGizmos.concat(foundGizmosByType);
      }
    }
    if (fid) {
      const foundGizmoByFid = childGizmos.find(
        childGizmo => childGizmo.getConfig().fid === fid
      );
      if (foundGizmoByFid) {
        foundGizmos.push(foundGizmoByFid);
      }
    } else if (uid && !fid) {
      const foundGizmoByUid = childGizmos.find(
        childGizmo => childGizmo.getConfig().uid === uid
      );

      if (foundGizmoByUid) {
        foundGizmos.push(foundGizmoByUid);
      }
    }

    for (const childGizmo of childGizmos) {
      const foundChildGizmos: (Gizmo | RootGizmo)[] = findGizmos({
        gizmo: childGizmo,
        type,
        fid,
        uid,
      });

      if (foundChildGizmos.length > 0) {
        foundGizmos = foundGizmos.concat(foundChildGizmos);
      }
    }
  }

  return foundGizmos;
}

export default findGizmos;
